module.exports = __webpack_public_path__ + "img/logo.464bdfb2.png";